import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { useStore } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Logout from '@mui/icons-material/Logout';

export function SidebarListLogout() {
  const store = useStore();
  const history = useHistory();

  return (
    <div
      onClick={() => {
        store.dispatch({ type: 'LOGOUT' });
        history.push('/');
      }}
    >
      <ListItem button>
        <ListItemIcon>
          <Logout />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItem>
    </div>
  );
}
